import { useState, useRef, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";

export default function TelehealthPermissionForm({
  patient,
  sigPad,
  signature,
  signedBy,
  relationship,
  viewOnly,
  date,
}) {
  useEffect(() => {
    if (viewOnly) {
      sigPad.current.fromData(signature);
    }
  }, [viewOnly]);

  return (
    <div className="rounded-lg overflow-hidden">
      <div className="p-6 max-w-4xl mx-auto ">
        <h1 className="text-3xl font-bold text-center mb-2">
          Telehealth Permission Form
        </h1>
        <p className="text-center text-gray-600 mb-6">
          Permission to Participate in Telehealth Consultation and Treatment
        </p>

        <div className="space-y-5 mb-6">
          <div>
            <h3 className="font-medium">1. Purpose:</h3>
            <p className="text-gray-800">
              The purpose of this Telehealth Permission Form is to get
              permission from patients to use the telehealth services during the
              treatment.
            </p>
          </div>
          <div>
            <h3 className="font-medium">2. Medical Information & Records:</h3>
            <p className="text-gray-800">
              Medical history and test details can be discussed with other
              professionals and can be used for further scientific studies. The
              patient will be contacted via video and audio during a telehealth
              appointment/visit. Video, audio, or any other digital photo of the
              patient can be recorded during the telehealth visit for treatment
              purposes only.
            </p>
          </div>
          <div>
            <h3 className="font-medium">3. Patient Rights:</h3>
            <p className="text-gray-800">
              The patient can withhold or withdraw the consent or permission to
              telehealth consultation/treatment at any time.
            </p>
          </div>
          <div>
            <h3 className="font-medium">4. Risks and Consequences:</h3>
            <p className="text-gray-800">
              The telehealth appointment/visit will be similar to the regular
              physical medical visit. Because this service uses videoconference
              technology, the visit may not be equivalent to or adequate as the
              regular physical visit. The patient may be recommended a visit
              physically after the telehealth visit by his or her physician.
            </p>
          </div>
          <div>
            <h3 className="font-medium">5. Confidentiality:</h3>
            <p className="text-gray-800">
              That is an obligation by the governmental laws to protect and kept
              private the personal or medical information of patients. All
              existing laws under federal will be for the physical treatment are
              also valid for telehealth treatment.
            </p>
          </div>
        </div>

        <div className="mb-4">
          <p className="block mb-1 text-gray-700">Patient Name:</p>
          <p className="border py-4 px-4 rounded-md text-sm">
            {`${patient.lastname} ${patient.firstname}`}
          </p>
        </div>

        <div className="mb-4">
          <p className="block mb-1 text-gray-700">Date:</p>
          <p className="border py-4 px-4 rounded-md text-sm">
            {viewOnly
              ? new Date(date).toLocaleDateString()
              : new Date().toLocaleDateString()}
          </p>
        </div>

        <div className="mb-4">
          <p className="block mb-1 text-gray-700">Signed By:</p>
          <p className="border py-4 px-4 rounded-md text-sm">
            {`${signedBy}`}
          </p>
        </div>
        <div className="mb-4">
          <p className="block mb-1 text-gray-700">Relationship with patient:</p>
          <p className="border py-4 px-4 rounded-md text-sm">
            {`${relationship}`}
          </p>
        </div>

        <div className="mb-4">
          <p className="block mb-1 text-gray-700">Signature:</p>
          <div className="border rounded-md p-2">
            <SignatureCanvas
              ref={sigPad}
              canvasProps={{
                className: `signature-canvas w-full h-40 bg-white ${
                  viewOnly ? "pointer-events-none" : ""
                }`,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
